import withReducer from '../../store/withReducer'
import EkgRecordingReviewScreen from './container'
import reducer from './module'

export default withReducer('ekgRecordingReviewScreen', reducer)(EkgRecordingReviewScreen)



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/index.js